<template>
    <!--Client Notifications Page-->
    <section id="client-profile">
        <div v-if="user && user.role == 'client'" class="client-appointments-notifications">
            <div class="client-heading">
                <h3>{{ $t("notifications.notificationSettings") }}</h3>
            </div>
            <div v-show="!loadingNotifications" class="notifications-message-wrap section-wrap">
                <div class="notifications-container section-wrap">
                    <span class="notifications-paragraph">
                        {{ $t("notifications.chooseNotifications") }}
                    </span>
                    <div class="checkbox-wrapper section-wrap highlighted-box">
                        <div class="checkbox-wrapp">
                            <div>
                                <p>Text Message</p>
                            </div>
                            <label class="switch">
                                <input id="text" type="checkbox" v-model="receive_sms"
                                    v-on:change="saveNotificationSettings" />
                                <label for="text" class="slider round"></label>
                            </label>
                        </div>
                        <div class="checkbox-wrapp">
                            <div>
                                <p>Push notification</p>
                            </div>
                            <label class="switch">
                                <input id="push" type="checkbox" v-model="receive_pushnotification"
                                    v-on:change="saveNotificationSettings" />
                                <label for="push" class="slider round"></label>
                            </label>
                        </div>
                        <div class="checkbox-wrapp">
                            <div>
                                <p>Email</p>
                            </div>
                            <label class="switch">
                                <input id="email" type="checkbox" v-model="receive_email"
                                    v-on:change="saveNotificationSettings" />
                                <label for="email" class="slider round"></label>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="book-btn" v-on:click="onBook()">
                    <div class="primary-btn extra-small mobile">Book a new appointment</div>
                </div>
                <client-notifications @loading="loadingNotifications = $event"></client-notifications>
            </div>
            <MainLoader class="section-wrap" v-if="loadingNotifications" />
        </div>
    </section>
</template>

<script>
import api from "../../services/apiEndpoints.js";
import auth from "../../services/auth.js";
import ClientNotifications from "./ClientNotifications.vue";
import messages from "../../services/messages.js";
import store from "../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import MainLoader from "./general-components/MainLoader.vue";

export default {
    name: "ClientAppointmentsNotifications",

    data: function () {
        return {
            user: null,
            receive_sms: 0,
            receive_pushnotification: 0,
            receive_email: 0,
            loadingNotifications: false,
        };
    },

    mounted: function () {
        this.user = auth.state.user;

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });
    },

    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },

    methods: {
        onAdminDetailsLoad: function () {
            this.receive_sms = !this.adminDetails.sms_off;
            this.receive_pushnotification = !this.adminDetails.pushnotifications_off;
            this.receive_email = !this.adminDetails.emails_off;
        },

        saveNotificationSettings() {
            let data = {
                emails_off: !this.receive_email,
                pushnotifications_off: !this.receive_pushnotification,
                sms_off: !this.receive_sms,
            };
            this.$http.post(api.actions.save_user_accounts, data).then(
                function (response) {
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.USER_DATA_SAVED_MESSAGE);
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        onBook: function () {
            this.$router.push("/app/stylists");
        },
    },

    components: {
        ClientNotifications,
        MainLoader,
    },
};
</script>
